export default __webpack_public_path__ + "static/media/Home-foto-header-corporate-Tower-viajes-desk@2x.9a4f4522.jpg";